import { render, staticRenderFns } from "./FullscreenDialog.vue?vue&type=template&id=94f4da12&scoped=true&"
import script from "./FullscreenDialog.vue?vue&type=script&lang=ts&"
export * from "./FullscreenDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f4da12",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94f4da12')) {
      api.createRecord('94f4da12', component.options)
    } else {
      api.reload('94f4da12', component.options)
    }
    module.hot.accept("./FullscreenDialog.vue?vue&type=template&id=94f4da12&scoped=true&", function () {
      api.rerender('94f4da12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/FullscreenDialog.vue"
export default component.exports